/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const resourceBulkWorkforceCategoryRequestSchema = z.object({
  resourceIds: z.array(z.int()).min(0).max(100),
  workforceCategory: z.enum(['EMPLOYEE', 'CONTRACTOR', 'VENDOR', 'FREELANCER']),
});
